<template lang="pug">
    div.media-list-control__item
        div.media-list-control__aspect-bone(v-if="squareAspect" :style="aspectBoneStyle")

        div.media-list-control__item-content(@click="itemClick" :style="itemContentStyle")
            img.media-list-control__item-image(v-if="imageType && !squareAspect" :src="mediaItem.url")
            video-player-control.media-list-control__item-video(v-if="videoType" :asset="mediaItem"
                    :fillMode="videoFillMode" :clickToPlay="false" :hideControls="true" @resize="videoResize")
        
        slot(name="decorate")
        
        resize-sensor(v-if="squareAspect" @resize="itemResize")
</template>

<script>
export default {
    name: 'media-list-control-item',

    props: {
        mediaItem: {
            type: Object,
            required: true,
        },
        mode: {
            type: String,
            required: true,
        },
        squareAspect: {
            type: Boolean,
        },
        clickCallback: {
            type: Function,
        },
    },

    data() {
        return {
            size: null,
        }
    },

    computed: {
        imageType() {
            return this.mediaItem.type == 'image'
        },
        videoType() {
            return this.mediaItem.type == 'video'
        },

        videoFillMode() {
            return this.squareAspect || this.mode == 'grid' || this.mode == 'slider'
        },

        aspectBoneStyle() {
            if (this.size) {
                const s = `${Math.max(this.size.width, this.size.height)}px`

                return {
                    'width': s,
                    'height': s,
                }
            }
        },
        itemContentStyle() {
            if (this.squareAspect) {
                const imgStyle = this.imageType ? {
                    'background-image': `url(${this.mediaItem.url})`,
                    'background-position': 'center',
                    'background-repeat': 'no-repeat',
                    'background-size': 'cover',
                } : null

                return {
                    'position': 'absolute',
                    'width': '100%',
                    'height': '100%',
                    'top': 0,
                    ...imgStyle,
                }
            }
        },
    },

    methods: {
        itemClick() {
            if (this.clickCallback) {
                this.clickCallback(this.mediaItem)
            }
            else {
                this.goToPost()
            }
        },

        goToPost() {
            this.$router.push(`/post/${this.mediaItem.post.data.id}`)
        },

        itemResize(e) {
            this.size = e
        },

        videoResize() {
            this.$emit('videoResize')
        },
    },
}
</script>
